import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { FaTrashAlt } from "react-icons/fa";

const getDefaultFiles2 = (
  defaultValues?: DefaultDropzoneValues
): (File | string)[] => {
  if (!defaultValues) return [];
  return Array.isArray(defaultValues) ? [...defaultValues] : [defaultValues];
};

export interface FileListProps {
  className?: string;
  multiple?: boolean;
  defaultValues?: DefaultDropzoneValues;
  onDrop: (files: (File | string)[]) => void;
}

export const FileList = ({
  onDrop,
  defaultValues,
  multiple = false,
  className,
}: FileListProps) => {
  const [files, setFiles] = useState<(File | string)[]>(
    getDefaultFiles2(defaultValues)
  );

  useEffect(() => {
    setFiles(getDefaultFiles2(defaultValues));
  }, [defaultValues]);

  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    // TODO maxSize, rejectedFiles?
    onDrop: (acceptedFiles) => {
      setFiles((pv) => {
        onDrop([...pv, ...acceptedFiles]);
        return [...pv, ...acceptedFiles];
      });
    },
  });

  return (
    <>
      <div>
        {files &&
          Array.from(files).map((file) => {
            const isString = typeof file === "string";
            const fileName = isString ? file : file.name;
            return (
              <div
                key={fileName}
                className="flex justify-end items-center gap-2"
              >
                <span className="text-sm">{fileName}</span>
                <FaTrashAlt
                  className="cursor-pointer"
                  onClick={() => {
                    setFiles((pv) => {
                      const newFiles = pv.filter((f) => f !== file);
                      onDrop(newFiles);
                      return newFiles;
                    });
                  }}
                />
              </div>
            );
          })}
      </div>
      <div
        {...getRootProps({
          className: className ?? "flex justify-end",
        })}
      >
        <input {...getInputProps()} />
        <label
          htmlFor="upload"
          className="font-semibold text-sm text-slate-400 hover:text-slate-800 cursor-pointer dark:hover:text-slate-200"
        >
          Dodaj załączniki
        </label>
      </div>
    </>
  );
};

type DefaultDropzoneValues = string | File | string[] | File[];
